<div class="issue-item"
     data-testid="issue-item"
     role="article"
     [attr.aria-label]="'Issue' + (getPrimaryDisplayName()) + ' - ' + issue().text">
  <div class="issue-content"
       data-testid="issue-content">
    <label class="issue-text"
           data-testid="issue-text"
           [attr.id]="'issue-text-' + issue().id">
      @if ((issue().assignedVendors && issue().assignedVendors.length > 0) || isSelfAssigned()) {
        <div class="body-s-bold vendor-assigned-to"
             data-testid="vendor-assigned-label">Assigned to:</div>
        @for (vendor of issue().assignedVendors; track $index) {
          <span [attr.data-testid]="'vendor-name-' + $index">
            {{ (vendor.vendorDetails.doingBusinessAs || vendor.vendorDetails.name) | titlecase}}
          </span>
        }
      }
      @if (isSelfAssigned()) {
        <div class="vendor-self-assigned"
             data-testid="vendor-self-assigned">Assigned to Me</div>
      }
      @if (getPrimaryDisplayName()) {
        <div class="area-name"
             data-testid="area-name">{{ getPrimaryDisplayName() }}:</div>
      }
      @if(issue().componentName) {
        <div class="component-name"
             data-testid="component-name">{{ issue().componentName }}</div>
      }
      <div class="due-date"
           data-testid="due-date">Due: {{ issue().dueDate ? (issue().dueDate | date:'MM/dd/yyyy') : 'TBD' }}</div>
      {{ issue().text }}
    </label>
  </div>

  <div class="issue-media"
       data-testid="issue-media"
       role="region"
       aria-label="Issue media attachments">
    <div class="media-grid"
         data-testid="media-grid"
         role="list"
         [attr.aria-label]="'Media attachments, ' + media().length + ' items'">
      @for (mediaUrl of media(); track $index; let mediaIndex = $index) {
        <img class="issue-image"
             [attr.data-testid]="'issue-image-' + mediaIndex"
             width="175px"
             height="150px"
             [src]="mediaUrl.imageData.azureBlobUri"
             [alt]="'Issue media attachment ' + (mediaIndex + 1) + ' of ' + media().length"
             (error)="onImageError(imgEl, placeholder)"
             #imgEl
             role="img" />
        <div class="issue-image-not-found"
             [attr.data-testid]="'issue-image-not-found-' + mediaIndex"
             hidden
             #placeholder>
          Image not found
        </div>
      }
    </div>
  </div>
</div>